import AuthMixin from '@/components/mixins/auth-mixin'
import { useMixpanel } from '@base-shared/composables/use-mixpanel'

export default {
  name: 'homePage',
  inject: [
    '$utils'
  ],
  components: {
  },
  mixins: [AuthMixin],
  data () {
    return {
      title: 'HomePage'
    }
  },
  methods: {},
  mounted () {
    useMixpanel().track('Home')
    this.isAuthenticated()
    this.$utils.animate('.home-card', 'animated fadeInLeft')
    this.$utils.animate('.desc', 'animated fadeInRight')
  }
}
